import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import api, {getJobLocalScripts, getLatestLocalInventoryFile, processLocalSnapshotFile} from "../../api";
import VarianceBlock from "../../components/VarianceBlock";
import DownloadReportsBlock from "../DownloadReportsBlock/index.store";
import ModalJob from "../ModalJob";
import useDebounce from "../../hooks/useDebounce";
import {
  fetchVarianceCheckingPartNumBin,
  fetchVarianceData,
  updateJob,
  updateJobStatus,
  getPendingTasks,
} from "../../store/actions";
import { fromApiDate, getDuration } from "../../utils/dateHelper";
import DashedLink from "../DashedLink";
import StatusChanger from "../StatusChanger";
import StatusModal from "../StatusModal";
import ButtonTransparent from "../ui/ButtonTransparent";
import DealerInfoModal from "./DealerInfoModal";
import "./index.css";
import VarianceListModal from "./VarianceListModal";
import VarianceListPreModal from "./VarianceListPreModal";
import ButtonSecondary from "../ui/ButtonSecondary";
import {
  isValidObject,
  isValidArray,
  getStatusMessageColor,
} from "../../utils/globalHelper";
import {
  GENERATE_COUNT_JOB_REPORTS_ACTION,
  FINALIZE_RESULT_COUNT_ACTION,
  PUSH_PARTNUM_COUNTS_TO_DMS_ACTION,
  JOB_ACTION_LIST,
} from "../../utils/constant";
import { getLocalStorage, setLocalStorage } from "../../utils/localStorage";
import FinalizeCountingResultsModal from "./FinalizeCountingResultsModal";
import {toast} from "react-toastify";

const jobStatusOptions = ["in progress", "scheduled", "completed", "canceled"];

const JobDetails = (props) => {
  const [formValues, setFormValues] = useState({
    name: props.job.name,
    notes: props.job.notes,
    scheduledStartTime: props.job.scheduledStartTime,
  });
  const debouncedSearchTerm = useDebounce(formValues, 750);
  const [isDealerModalOpen, setIsDealerModalOpen] = useState(null);
  const [isVarianceListModalOpen, setIsVarianceListModalOpen] = useState(null);
  const [isVarianceListPreModalOpen, setIsVarianceListPreModalOpen] =
    useState(null);
  const [isVarianceListButtonDisabled, setIsVarianceListButtonDisabled] =
    useState(true);
  const [duration, setDuration] = useState("");
  const [varianceData, setVarianceData] = useState(null);
  const [usersData, setUsersData] = useState(null);
  const [isVarianceDataPopulating, setIsVarianceDataPopulating] =
    useState(false);
  const [lastRun, setLastRun] = useState("");
  const [isVarianceDataNotPopulated, setIsVarianceDataNotPopulated] =
    useState(false);
  const [lastRunType, setLastRunType] = useState("");
  const [lastRunStatus, setLastRunStatus] = useState("");
  const [showVarianceButtons, setShowVarianceButtons] = useState(false);
  const [isJobModalOpen, setIsJobModalOpen] = useState(false);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [showDataPickerJobsReports, setShowDataPickerJobsReports] =
    useState(false);
  const [showPushCountDmsModal, setShowPushCountDmsModal] = useState(false);
  const [isJobFinalizeCountDone, setIsJobFinalizeCountDone] = useState(false);
  const [taskJobId, setTaskJobId] = useState("");
  const [loadingAtStatus, setLoadingAtStatus] = useState(false);
  const [generatedCountTaskUuid, setGeneratedCountTaskUuid] = useState("");
  const [finalizeCountTaskUuid, setFinalizeContTaskUuid] = useState("");
  const [generateCountTaskStatus, setGenerateCountTaskStatus] = useState("");
  const [finalizeCountTaskStatus, setFinalizeCountTaskStatus] = useState("");
  const [pushPartnumCountTaskStatus, setPushPartnumCountTaskStatus] =
    useState("");
  const [pushPartnumTaskUuid, setPushPartnumTaskUuid] = useState("");
  const [refreshTasksStatus, setRefreshTasksStatus] = useState(false);
  const [snapshotFile, setSnapshotFile] = useState();
  const [inSnapshotUploading, setInSnapshotUploading] = useState(false);
  const [inUpdateJobSetupData, setInUpdateJobSetupData] = useState(false);

  const job =
    props && isValidObject(props) && props?.["job"] ? props["job"] : {};
  const jobStatus =
    props && isValidObject(props) && props?.status ? props?.status : "";

  useEffect(() => {
    if (props.status === "scan_completed") {
      setLastRun(props.orders[props.orders.length - 1]);
      setShowVarianceButtons(true);
    }
  }, [props.status]);

  useEffect(() => {
    if (props.status === "scan_completed")
      props.getPendingTasks(props.job.UUID);
    else
      props.getPendingTasks(props.job.UUID);
  }, [props.status]);

  useEffect(() => {
    if (lastRun) {
      setLastRunType(lastRun.type);
      setLastRunStatus(lastRun.status);
    }
  }, [props.orders]);

  // useEffect(() => {
  //   if (props.status === 'completed') {
  //     setLastRunType(null)
  //     setLastRunStatus(null)
  //     setLastRun(null)
  //   }
  // }, [ props.status ])

  /**
   * Manage the taskJobId and enabling the push_partnum_counts_to_dms btn
   */

  useEffect(() => {
    const jobActionList = getLocalStorage(JOB_ACTION_LIST, true)
      ? getLocalStorage(JOB_ACTION_LIST, true)
      : [];
    const jobId = job && isValidObject(job) && job?.UUID ? job["UUID"] : "";

    if (isValidArray(jobActionList) && jobId) {
      const jobActionItem = jobActionList.find((item) => item.jobId === jobId);

      if (jobActionItem && isValidObject(jobActionItem)) {
        setGeneratedCountTaskUuid(
          jobActionItem?.actionMethod?.generatedTaskUuid
        );
        setFinalizeContTaskUuid(
          jobActionItem?.actionMethod?.finalizeCountTaskUuid
        );
        setPushPartnumTaskUuid(
          jobActionItem?.actionMethod?.pushPartnumCountTaskUuid
        );
        setTaskJobId(jobActionItem?.actionMethod?.taskUuid);
        setIsJobFinalizeCountDone(
          jobActionItem?.actionMethod?.isPushPartnumCountToDmsActionDone
        );
      }
    }
  }, [job]);

  useEffect(() => {
    (async () => {
      if (props.job.status === "scan_completed") {
        let varianceData, usersData;
        varianceData = await props.fetchVarianceData(props.job.UUID);
        if (!varianceData.data.data) {
          setIsVarianceDataNotPopulated(true);
        } else {
          usersData = await api.getVarianceCheckingUserAssignments(
            props.job.UUID
          );
          setUsersData(usersData.data);
          setVarianceData(varianceData.data);
        }
        setIsVarianceListButtonDisabled(false);
      }
    })();
  }, [isDealerModalOpen]);

  /**
   * Manage the Task status of applied task on basis of taskUUid
   */

  useEffect(() => {
    const getTaskStatus = async () => {
      // if (!taskJobId) return;
      // if (!getStatusOfJob(jobStatus)) return;

      setLoadingAtStatus(true);

      if (generatedCountTaskUuid) {
        const generatedCountTaskRequest = await api.getJobTaskStatus(
          generatedCountTaskUuid
        );
        if (
          generatedCountTaskRequest &&
          generatedCountTaskRequest.status === 200
        ) {
          setGenerateCountTaskStatus(
            generatedCountTaskRequest.data.data.taskStatus
          );
        }
      }

      if (finalizeCountTaskUuid) {
        const finalizeCountTaskRequest = await api.getJobTaskStatus(
          finalizeCountTaskUuid
        );
        if (
          finalizeCountTaskRequest &&
          finalizeCountTaskRequest.status === 200
        ) {
          setFinalizeCountTaskStatus(
            finalizeCountTaskRequest.data.data.taskStatus
          );
        }
      }

      if (pushPartnumTaskUuid) {
        const pushPartnumTaskRequest = await api.getJobTaskStatus(
          finalizeCountTaskUuid
        );
        if (pushPartnumTaskRequest && pushPartnumTaskRequest.status === 200) {
          setPushPartnumCountTaskStatus(
            pushPartnumTaskRequest.data.data.taskStatus
          );
        }
      }

      setLoadingAtStatus(false);
    };
    getTaskStatus();
  }, [
    job,
    taskJobId,
    generatedCountTaskUuid,
    finalizeCountTaskUuid,
    pushPartnumTaskUuid,
    refreshTasksStatus,
  ]);

  const updateFields = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setFormValues({
      name: props.job.name,
      notes: props.job.notes,
      scheduledStartTime: props.job.scheduledStartTime,
    });
  }, [props.job]);

  useEffect(() => {
    const initialJob = props.job;
    if (
      initialJob.name === formValues.name &&
      initialJob.notes === formValues.notes &&
      initialJob.scheduledStartTime === formValues.scheduledStartTime
    ) {
      return;
    }

    if (debouncedSearchTerm) {
      props.updateJob(
        {
          scheduledStartTime: formValues.scheduledStartTime,
          name: formValues.name,
          dealerUUID: props.job.dealerUUID,
          notes: formValues.notes,
        },
        props.job.UUID
      );
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const intervalID = setTimeout(() => {
      setRefreshTasksStatus((refreshTaskStatus) => !refreshTaskStatus);
    }, 20000);
    return () => clearInterval(intervalID);
  }, [refreshTasksStatus]);

  useEffect(() => {
    const duration = props.job.completedTime
      ? getDuration(props.job.completedTime, props.job.startedTime)
      : "";
    setDuration(duration);
  }, [props.job]);

  const submit = async (e) => {
    e.preventDefault();
    if (props.job.status === "scheduled") {
      await api.startScan(props.job.UUID);
      window.history.go();
    } else if (props.job.status === "scan_started") {
      await api.completeScan(props.job.UUID);
      window.history.go();
    } else if (props.job.status === "scan_completed") {
      await setIsJobModalOpen(true);
      // await props.updateJobStatus(props.job.UUID, 'completed')
    }
  };

  const abortJob = async (e) => {
    e.preventDefault();
    if (props.job.status === "scheduled") {
      await props.updateJobStatus(props.job.UUID, "canceled");
    } else {
      await api.abortJob(props.job.UUID);
      window.history.go();
    }
  };

  const doNothing = async (e) => {
    e.preventDefault();
  };

  const handleSnapshotFileChange = (event) => {
    console.log(event.target.files[0]);
    setSnapshotFile(event.target.files[0]);
    // console.log(snapshotFile.name);
  };

  const handleSnapshotFileSubmit = async(e) => {
    console.log("***** snapshotFile.name", snapshotFile.name);
    e.preventDefault();
    // const url = 'http://localhost:3000/uploadFile';
    // const config = {
    //   headers: {
    //     'content-type': 'multipart/form-data',
    //   },
    // };
    // axios.post(url, formData, config).then((response) => {
    //   console.log(response.data);
    // });

    setInSnapshotUploading(true);
    const formData = new FormData();
    formData.append('file', snapshotFile);
    formData.append('fileName', snapshotFile.name);
    let uploadResponse;
    uploadResponse = await api.processLocalSnapshotFile(props.job.dealerUUID, formData);
    setInSnapshotUploading(false);
    if(uploadResponse.data.status === "success")
    {
      toast.warn("Snapshot successfully uploaded!", {
        position: toast.POSITION.TOP_CENTER,
        onClose: () => {
          // Action to perform after the toast is closed
          window.history.go();
        }
      });
    }
    else
    {
      toast.warn("Failed to upload snapshot. " + uploadResponse.data.message, {
        position: toast.POSITION.TOP_CENTER,
        onClose: () => {
          // Action to perform after the toast is closed
          window.history.go();
        }
      });
    }
    // window.history.go();
  }

  const handleLocalScriptFileDownload = async(e, i_script_type) => {
    e.preventDefault();
    try
    {
      const response = await api.getJobLocalScripts(props.job.UUID, i_script_type); // "scripts_bin_location");
      // console.log("response.headers =", response.headers);
      // console.log("response.headers['content-disposition'] =", response.headers['content-disposition']);
      // console.log("response.headers['content-type'] =", response.headers['content-type']);
      // Extract filename from header
      const filename = response.headers['content-disposition'] //get('content-disposition')
        .split(';')
        .find(n => n.includes('filename='))
        .replace('filename=', '').replace(/"/g, '')
        .trim()
      ;

      // const filename = "bin_location_update_script__Lithia_Cjdr_Sante_Fe_1740332658999.csv";

      console.log("filename =", filename);

      innerDownloadBlobAsFile(response.data, filename);

      // // Create a Blob from the response data
      // const pdfBlob = new Blob([response.data]);
      //
      // // Create a temporary URL for the Blob
      // const temp_url = window.URL.createObjectURL(pdfBlob);
      //
      // // Create a temporary <a> element to trigger the download
      // const tempLink = document.createElement("a");
      // tempLink.href = temp_url;
      // tempLink.setAttribute(
      //     "download",
      //     filename
      // ); // Set the desired filename for the downloaded file
      //
      // // Append the <a> element to the body and click it to trigger the download
      // document.body.appendChild(tempLink);
      // tempLink.click();
      //
      // // Clean up the temporary elements and URL
      // document.body.removeChild(tempLink);
      // window.URL.revokeObjectURL(temp_url);
    }
    catch (error) {
      console.error("Error downloading local script file:", error);
    }
  }

  const handleLatestLocalInventoryFileFileDownload = async(e) => {
    e.preventDefault();
    try
    {
      const response = await api.getLatestLocalInventoryFile(props.job.dealerUUID);
      const filename = response.headers['content-disposition'] //get('content-disposition')
          .split(';')
          .find(n => n.includes('filename='))
          .replace('filename=', '').replace(/"/g, '')
          .trim()
      ;

      // const filename = "bin_location_update_script__Lithia_Cjdr_Sante_Fe_1740332658999.csv";

      console.log("filename =", filename);
      innerDownloadBlobAsFile(response.data, filename);
    }
    catch (error) {
      console.error("Error downloading latest local inventory file:", error);
    }
  }

  const innerDownloadBlobAsFile = (i_blob, i_filename) => {
    // Create a Blob from the response data
    const vBlob = new Blob([i_blob]);

    // Create a temporary URL for the Blob
    const temp_url = window.URL.createObjectURL(vBlob);

    // Create a temporary <a> element to trigger the download
    const tempLink = document.createElement("a");
    tempLink.href = temp_url;
    tempLink.setAttribute(
        "download",
        i_filename
    ); // Set the desired filename for the downloaded file

    // Append the <a> element to the body and click it to trigger the download
    document.body.appendChild(tempLink);
    tempLink.click();

    // Clean up the temporary elements and URL
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(temp_url);
  }

  const handleUpdateJobSetupData = async(e) => {
    e.preventDefault();
    setInUpdateJobSetupData(true);
    await api.updateJobSetupData(props.job.UUID);
    setInUpdateJobSetupData(false);
  }

  // const handleToastfyTest = (e) => {
  //   e.preventDefault();
  //   toast.warn("TEST Message", {
  //     position: toast.POSITION.TOP_CENTER
  //   });
  // }

  const onSelectStatus = (e) => console.log("csac");

  const confirmButton = (status) => {
    switch (status) {
      case "scheduled":
        return (
          <input
            type="submit"
            value="Start Job"
            className="job-details__form-submit btn btn--primary"
          />
        );
      case "scan_started":
        return (
          <input
            type="submit"
            value="Scan Completed"
            className="job-details__form-submit btn btn--primary"
          />
        );
      case "scan_completed":
        return (
          <input
            type="submit"
            value="Complete Job"
            className="job-details__form-submit btn btn--primary"
          />
        );
      default:
        return null;
    }
  };

  const toggleDealerModal = (id) => {
    if (id) {
      const dealer = props.dealerList.find((dealer) => dealer.UUID === id);
      setIsDealerModalOpen({ dealer });
    } else {
      setIsDealerModalOpen(!isDealerModalOpen);
    }
  };

  const toggleVarianceListModal = async (e) => {
    e && e.preventDefault();
    setIsVarianceListModalOpen(!isVarianceListModalOpen);
    if (!e) {
      setIsVarianceListButtonDisabled(true);
      const [varianceData, usersData] = await Promise.all([
        props.fetchVarianceCheckingPartNumBin(props.job.UUID),
        api.getVarianceCheckingUserAssignments(props.job.UUID),
      ]);

      setIsVarianceListButtonDisabled(false);
      setUsersData(usersData.data);
      setVarianceData(varianceData.data);
    }
  };

  const toggleVarianceListPreModal = (isClose) => {
    setIsVarianceListPreModalOpen(
      isClose ? isClose : !isVarianceListPreModalOpen
    );
  };
  const toggleDatePickerJobReports = () => {
    setShowDataPickerJobsReports(!showDataPickerJobsReports);
  };

  const selectCountingMode = async (countingMode) => {
    setIsVarianceDataPopulating(true);
    await api.createVarianceChecking(
      props.job.UUID,
      countingMode,
      "initial_run"
    );
    const [varianceData, usersData] = await Promise.all([
      props.fetchVarianceCheckingPartNumBin(props.job.UUID),
      api.getVarianceCheckingUserAssignments(props.job.UUID),
    ]);
    setUsersData(usersData.data);
    setVarianceData(varianceData.data);
    setIsVarianceDataNotPopulated(false);
    setIsVarianceDataPopulating(false);
    setIsVarianceListPreModalOpen(false);
    setIsVarianceListModalOpen(true);
  };

  const onClickCounting = (e) => {
    e.preventDefault();
  };
  const onClickVariance = (e) => {
    e.preventDefault();
  };
  const onClickSendVarianceList = (e) => {
    e && e.preventDefault();
    if (isVarianceDataNotPopulated) {
      toggleVarianceListPreModal(true);
    } else {
      toggleVarianceListModal();
    }
  };
  const onClickViewProgress = (e) => {
    e.preventDefault();
    props.history.push(`/jobs/${props.job.UUID}/variance`);
  };

  const isReadOnly =
    props.status === "completed" ||
    props.status === "canceled" ||
    props.status === "aborted";

  /**
   * Manage the New Action Job Activities and also store the activity list in the localStorage.
   * @param {string} actionMethod
   * @param {string} jobId
   */

  const manageActionActivity = (actionMethod, jobId) => {
    const jobActionList = getLocalStorage(JOB_ACTION_LIST, true);

    if (jobActionList && isValidArray(jobActionList)) {
      const jobActionItemIndex = jobActionList.findIndex(
        (item) => item.jobId === jobId
      );

      if (jobActionItemIndex >= 0) {
        const jobActionMethod =
          jobActionList[jobActionItemIndex] &&
          jobActionList[jobActionItemIndex]?.["actionMethod"]
            ? jobActionList[jobActionItemIndex]["actionMethod"]
            : {};

        jobActionList[jobActionItemIndex] = {
          actionMethod: {
            ...jobActionMethod,
            ...actionMethod,
          },
          jobId,
        };
        setLocalStorage(JOB_ACTION_LIST, jobActionList);
      } else {
        const action = [
          ...jobActionList,
          {
            actionMethod,
            jobId,
          },
        ];
        setLocalStorage(JOB_ACTION_LIST, action);
      }
    } else {
      const action = [
        {
          actionMethod,
          jobId,
        },
      ];
      setLocalStorage(JOB_ACTION_LIST, action);
    }
  };

  /**
   * Manage the Api call for the new jobs on the basis of taskType
   * @param {string} taskType
   * @returns
   */
  const addNewJobTask = async (taskType) => {
    const jobId = job && isValidObject(job) && job["UUID"];

    if (!jobId) return;

    const taskData = {
      taskName: null,
      taskData: null,
    };

    if (taskType === GENERATE_COUNT_JOB_REPORTS_ACTION) {
      taskData["taskName"] = GENERATE_COUNT_JOB_REPORTS_ACTION;
    }

    if (taskType === FINALIZE_RESULT_COUNT_ACTION) {
      taskData["taskName"] = FINALIZE_RESULT_COUNT_ACTION;
      setIsJobFinalizeCountDone(true);
    }

    if (taskType === PUSH_PARTNUM_COUNTS_TO_DMS_ACTION) {
      taskData["taskName"] = PUSH_PARTNUM_COUNTS_TO_DMS_ACTION;
    }

    const result = await api.newJobTask(jobId, taskData);
    const taskUuid =
      result && result?.["data"]?.["data"]?.["UUID"]
        ? result["data"]["data"]["UUID"]
        : null;

    if (result && result.status === 200 && taskUuid) {
      if (taskData["taskName"] === GENERATE_COUNT_JOB_REPORTS_ACTION) {
        setGeneratedCountTaskUuid(taskUuid);
        manageActionActivity(
          {
            isGeneratedCountActionDone: true,
            isFinalizeResultCountActionDone: true,
            isPushPartnumCountToDmsActionDone: false,
            generatedTaskUuid: taskUuid,
          },
          jobId
        );
      }

      if (taskData["taskName"] === FINALIZE_RESULT_COUNT_ACTION) {
        setFinalizeContTaskUuid(taskUuid);
        manageActionActivity(
          {
            isGeneratedCountActionDone: true,
            isFinalizeResultCountActionDone: true,
            isPushPartnumCountToDmsActionDone: true,
            finalizeCountTaskUuid: taskUuid,
          },
          jobId
        );
      }

      if (taskData["taskName"] === PUSH_PARTNUM_COUNTS_TO_DMS_ACTION) {
        setPushPartnumTaskUuid(taskUuid);
        manageActionActivity(
          {
            isGeneratedCountActionDone: true,
            isFinalizeResultCountActionDone: true,
            isPushPartnumCountToDmsActionDone: true,
            pushPartnumCountTaskUuid: taskUuid,
          },
          jobId
        );
      }
    }

    setShowPushCountDmsModal(false);
  };

  const isJobReady = getStatusOfJob(jobStatus);

  /**
   *  Manage the status of job on boolean type on the basis of status string
   * @param {string} statusValue
   * @returns jobStatus boolean value
   */

  function getStatusOfJob(statusValue) {
    const jobStatusValue = statusValue;
    let jobStatus;

    switch (jobStatusValue) {
      case "scan_started":
        jobStatus = true;
        break;
      case "completed":
        jobStatus = true;
        break;
      case "scan_completed":
        jobStatus = true;
        break;
      default:
        jobStatus = false;
    }

    return jobStatus;
  }


  return (
    <div className="job-details">
      <h3 className="job-details__title">Job info</h3>
      <form className="job-details__form" onSubmit={submit} autoComplete="off">
        <div className="job-details__form-group">
          <label className="job-details__form-label" htmlFor="status">
            Status
          </label>
          <StatusChanger
              isReadOnly={true}
              className="job-details__status-changer"
              currentStatus={props.job.status}
              options={jobStatusOptions}
              onSelectStatus={onSelectStatus}
          />
        </div>
        <div className="job-details__form-group">
          <label className="job-details__form-label" htmlFor="barcode">
            Job ID
          </label>
          <p className="job-details__job-id">{props.job.UUID}</p>
        </div>
        <div className="job-details__form-group">
          <label className="job-details__form-label" htmlFor="jobName">
            Job Name
          </label>
          <input
              readOnly
              className="job-details__form-input"
              id="jobName"
              type="text"
              value={formValues.name}
              name="name"
              onChange={updateFields}
          />
        </div>
        <div className="job-details__form-group">
          <label className="job-details__form-label" htmlFor="dealerName">
            Dealer Name
          </label>
          <DashedLink
              className="job-details__add-info"
              name={props.job.dealer}
              onClick={() => toggleDealerModal(props.job.dealerUUID)}
          />
        </div>
        {props.status === "completed" ? (
            <>
              <div className="job-details__form-group">
                <label className="job-details__form-label" htmlFor="time-started">
                  Started
                </label>
                <input
                    className="job-details__form-input"
                    readOnly
                    id="time-started"
                    type="text"
                    value={
                      props.job.startedTime
                          ? fromApiDate(props.job.startedTime)
                          : ""
                    }
                    name="time-started"
                />
              </div>
              <div className="job-details__form-group">
                <label
                    className="job-details__form-label"
                    htmlFor="time-finished"
                >
                  Finished
                </label>
                <input
                    className="job-details__form-input"
                    readOnly
                    id="time-finished"
                    type="text"
                    value={
                      props.job.completedTime
                          ? fromApiDate(props.job.completedTime)
                          : ""
                    }
                    name="time-finished"
                />
              </div>
              <div className="job-details__form-group">
                <label
                    className="job-details__form-label"
                    htmlFor="time-duration"
                >
                  Duration
                </label>
                <input
                    className="job-details__form-input"
                    readOnly
                    id="time-duration"
                    type="text"
                    value={duration}
                    name="time-duration"
                />
              </div>
            </>
        ) : (
            <div className="job-details__form-group">
              <label className="job-details__form-label" htmlFor="time">
                Scheduled time
              </label>
              <input
                  onClick={
                    ["completed", "canceled", "aborted"].includes(props.status)
                        ? null
                        : props.toggleDateTimePicker
                  }
                  className="job-details__form-input"
                  readOnly
                  id="time"
                  type="text"
                  value={fromApiDate(formValues.scheduledStartTime)}
                  name="time"
              />
            </div>
        )}
        <div className="job-details__form-group">
          <label className="job-details__form-label" htmlFor="barcode">
            Last Snapshot Time
          </label>
          <p className="job-details__job-id">{props.job.lastSnapshotTime}</p>
        </div>
        <div className="job-details__form-group">
          <label
              className="job-details__form-label job-details__form-label--textarea"
              htmlFor="notes"
          >
            Note
          </label>
          <textarea
              readOnly={isReadOnly}
              className="job-details__form-textarea"
              id="notes"
              type="text"
              value={formValues.notes}
              name="notes"
              onChange={updateFields}
          />
        </div>
        {props.status === "scan_completed" && (
            <div>
              <VarianceBlock
                  isVarianceListButtonDisabled={isVarianceListButtonDisabled}
                  onClickSendVarianceList={onClickSendVarianceList}
                  onClickViewProgress={onClickViewProgress}
                  job={props.job}
              />
            </div>
        )}

        <div className="groove-border-with-pad">
          <h3>Inventory Snapshot</h3>
          <br/>
          <form onSubmit={doNothing}>
            <input type="file" onChange={handleSnapshotFileChange}
                   className="force-paddown18"
            />
            <ButtonSecondary
                name={inSnapshotUploading ? "Uploading Snapshot ..." : "Upload Inventory Snapshot"}
                disabled={(!snapshotFile) || (inSnapshotUploading)}
                // type="submit"
                onClick={handleSnapshotFileSubmit}
                className="btn btn--primary"
            />
          </form>
          <br/>
          <ButtonSecondary
              name={inUpdateJobSetupData ? "Updating Job Data ..." : "Update Job Setup Data"}
              disabled={inUpdateJobSetupData}
              onClick={handleUpdateJobSetupData}
              className="btn btn--primary"
          />
          <br/>
          <ButtonSecondary
              name={"Download Last Inventory Snapshot File"}
              onClick={handleLatestLocalInventoryFileFileDownload}
              className="btn btn--primary"
          />
        </div>

        <br/>
        <div className="groove-border-with-pad">
          <h3>Local Scripts</h3>
          <br/>
          <ButtonSecondary
              name={"Bin Location Script"}
              // disabled={(!snapshotFile) || (inSnapshotUploading)}
              // type="submit"
              onClick={(event) => handleLocalScriptFileDownload(event, "scripts_bin_location")}
              className="btn btn--primary"
          />
          <br/>
          <ButtonSecondary
              name={"Partnum Count Script"}
              onClick={(event) => handleLocalScriptFileDownload(event, "scripts_partnum_count")}
              className="btn btn--primary"
          />
          <br/>
          <ButtonSecondary
              name={"Original Count Script"}
              onClick={(event) => handleLocalScriptFileDownload(event, "scripts_original_count")}
              className="btn btn--primary"
          />
          <br/>
          <ButtonSecondary
              name={"Simple Partnum Count Script"}
              onClick={(event) => handleLocalScriptFileDownload(event, "scripts_simple_partnum_count")}
              className="btn btn--primary"
          />
        </div>

        <DownloadReportsBlock
            toggleDatePickerReports={toggleDatePickerJobReports}
            title="Job Reports"
        />

        {(lastRunType === "final_run" && lastRunStatus === "completed") ||
        showVarianceButtons ? null : (
            <div className="job-details__form-group job-details__controls">
              <div className="job-details__controls-row">
                {confirmButton(props.status)}
                {props.status !== "aborted" &&
                    props.status !== "scan_completed" &&
                    props.status !== "completed" && (
                        <ButtonTransparent
                            name={
                              props.status === "scheduled" ? "Cancel Job" : "Abort Job"
                            }
                            onClick={abortJob}
                            className="job-details__form-submit btn btn--transparent"
                        />
                    )}
                {props.status === "scan_completed" && (
                    <ButtonTransparent
                        name="Abort Job"
                        onClick={abortJob}
                        className="job-details__form-submit btn btn--transparent-sick"
                    />
                )}
              </div>

              {props.status === "scan_completed" && (
                  <ButtonSecondary
                      name="Confirm PHP is run"
                      onClick={() =>
                      {
                      }}
                      className="job-details__form-submit btn btn--transparent-sick"
                  />
              )}
            </div>
        )}

        <div className="job-info__btn-container">
          <div className="job-info__btn-item_container">
            <div
                className="status_circle_div"
                style={{
                  backgroundColor: isJobReady ? "#0BDA51" : "#FF2400",
                }}
            />
            <ButtonSecondary
                name="Generate Counting Job Reports"
                code="generate_counting_job_reports"
                id="generate_counting_job"
                onClick={() => addNewJobTask(GENERATE_COUNT_JOB_REPORTS_ACTION)}
                className="job-details__form-submit btn btn--transparent-sick job-info__btn-child-item"
                disabled={!isJobReady}
            />

            <div className="job_info_btn-item-status-container job_info_btn-item-status">
              {generatedCountTaskUuid && (
                  <>
                    <label className="label_custom_width">{`Task-Status`}</label>
                    {" : "}
                    {loadingAtStatus ? (
                        <span className="status_txt_label">{"Loading ..."}</span>
                    ) : (
                        <span
                            style={{
                              color: getStatusMessageColor(generateCountTaskStatus),
                            }}
                            className="status_txt_label"
                        >
                      {generateCountTaskStatus}
                    </span>
                    )}
                  </>
              )}
            </div>
          </div>

          <div className="job-info__btn-item_container">
            <div
                className="status_circle_div"
                style={{
                  backgroundColor: isJobReady ? "#0BDA51" : "#FF2400",
                }}
            />

            <ButtonSecondary
                name="Finalize Counting Results"
                code="finalize_counting_results"
                className="job-details__form-submit btn btn--transparent-sick job-info__btn-child-item"
                onClick={() => addNewJobTask(FINALIZE_RESULT_COUNT_ACTION)}
                disabled={!isJobReady}
            />
            <div className="job_info_btn-item-status-container job_info_btn-item-status">
              {finalizeCountTaskUuid && (
                  <>
                    <label className="label_custom_width">{`Task-Status`}</label>
                    {" : "}
                    {loadingAtStatus ? (
                        <span className="status_txt_label">{"Loading ..."}</span>
                    ) : (
                        <span
                            style={{
                              color: getStatusMessageColor(finalizeCountTaskStatus),
                            }}
                            className="status_txt_label"
                        >
                      {finalizeCountTaskStatus}
                    </span>
                    )}
                  </>
              )}
            </div>
          </div>

          <div className="job-info__btn-item_container">
            <div
                className="status_circle_div"
                style={{
                  backgroundColor:
                      isJobReady && isJobFinalizeCountDone ? "#0BDA51" : "#FF2400",
                }}
            />

            <ButtonSecondary
                name="Push Partnum Counts to DMS"
                code="push_partnum_counts_to_dms"
                className="job-details__form-submit btn btn--transparent-sick job-info__btn-item"
                disabled={isJobReady && isJobFinalizeCountDone ? false : true}
                onClick={() =>
                    setShowPushCountDmsModal(
                        (showPushCountDmsModal) => !showPushCountDmsModal
                    )
                }
            />

            <div className="job_info_btn-item-status-container job_info_btn-item-status">
              <>
                {pushPartnumTaskUuid && (
                    <>
                      <label className="label_custom_width">{`Task-Status`}</label>
                      {" : "}
                      {loadingAtStatus ? (
                          <span className="status_txt_label">{"Loading ..."}</span>
                      ) : (
                          <span
                              style={{
                                color: getStatusMessageColor(
                                    pushPartnumCountTaskStatus
                                ),
                              }}
                              className="status_txt_label"
                          >
                        {pushPartnumCountTaskStatus}
                      </span>
                      )}
                    </>
                )}
              </>
            </div>
          </div>
        </div>
      </form>

      {isDealerModalOpen && (
          <DealerInfoModal
              dealer={isDealerModalOpen.dealer}
              onClose={() => toggleDealerModal(null)}
          />
      )}
      {isJobModalOpen && (
          <ModalJob
              setIsJobModalOpen={setIsJobModalOpen}
              setIsStatusModalOpen={setIsStatusModalOpen}
              id={props.job.UUID}
              job={props.job}
          />
      )}

      {isStatusModalOpen && (
          <StatusModal
              id={props.job.UUID}
              setIsStatusModalOpen={setIsStatusModalOpen}
          />
      )}

      {isVarianceListModalOpen && (
        <VarianceListModal
          onClose={() => toggleVarianceListModal(null)}
          varianceData={varianceData}
          usersData={usersData}
          job={props.job.UUID}
        />
      )}
      {isVarianceListPreModalOpen && (
        <VarianceListPreModal
          onClose={() => toggleVarianceListPreModal(null)}
          onSelect={selectCountingMode}
          isLoading={isVarianceDataPopulating}
        />
      )}

      {showPushCountDmsModal && (
        <FinalizeCountingResultsModal
          onClose={() =>
            setShowPushCountDmsModal(
              (showPushCountDmsModal) => !showPushCountDmsModal
            )
          }
          onSelect={() => addNewJobTask(PUSH_PARTNUM_COUNTS_TO_DMS_ACTION)}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({
  dealers: { dealerList },
  data: { orders, tasks },
}) => ({ dealerList, orders, tasks });

const mapDispatchToProps = {
  updateJob,
  updateJobStatus,
  fetchVarianceData,
  fetchVarianceCheckingPartNumBin,
  getPendingTasks,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(JobDetails));
